/* eslint-disable max-len */
/* eslint-disable no-console */
import {
  executeImage,
  executeImageColor,
  explorerImage,
  explorerImageColor,
  notificationImage,
  notificationImageColor,
  notificationErrorImage,
  notificationErrorImageColor,
  notificationSuccessImage,
  notificationSuccessImageColor,
  notificationWarningImage,
  notificationWarningImageColor,
  streamImage,
  streamImageColor,
  specifyFlowIcon,
  specifyFlowIconColor,
  pdfReportImage,
  pdfReportImageColor
} from './assets/images';

// Override the console data in console tab by chandrashekhar GB-3003
// if (['prod', 'qa', 'dev'].indexOf(process.env.REACT_APP_ENV) >= 0) {
//   console.log = function () { };
// }
export const modifiedDate = '2025-11-21';

export const controlsButtonTitle = ['Zoom In', 'Zoom Out', 'Fit View', 'Toggle Interactivity', 'Height', 'Width'];

export const waterSource = [
  { id: 1, name: 'RO Permeate' },
  { id: 2, name: 'Brackish Wellwater' },
  { id: 3, name: 'Brackish Surfacewater (MF/UF)' },
  { id: 4, name: 'Brackish Surfacewater (Conventional)' },
  { id: 5, name: 'Sea Wellwater' },
  { id: 6, name: 'Surface Seawater (MF/UF)' },
  { id: 7, name: 'Surface Seawater (Conventional)' },
  { id: 8, name: 'Tertiary Treated Wastewater (MF/UF)' },
  { id: 9, name: 'Tertiary Treated Wastewater (Conventional)' },
  { id: 10, name: 'MBR Permeate' },
  // { id: 11, name: 'High ph RO (city/well)' }, // commented by Abhishek on 30-may-24 as part of GB-2215
  // { id: 12, name: 'High ph RO Wastewater' },
  // { id: 13, name: 'High ph RO 2nd pass' },
];

export const waterType = [
  { id: 1, name: 'User Defined' },
  { id: 2, name: 'Sea Water' },
  { id: 3, name: 'Surface Water' },
  { id: 4, name: 'Sweet Water' },
  { id: 5, name: 'Sour Water' },
  { id: 6, name: 'Brackish Water' },
  { id: 7, name: 'Well Water' },
  { id: 8, name: 'EDI' }
];

export const cationCodes = [
  'Ca++',
  'Mg++',
  'Na+',
  'K+',
  'Fe++',
  'Ba++',
  'Mn++',
  'NH4+',
  'Sr++',
];
export const anionCodes = [
  'SO4--',
  'Cl-',
  'F-',
  'NO3-',
  'Br-',
  'PO4---',
  'B-',
  'SiO2',
  'H2S',
  'HCO3-',
  'CO2',
  'CO3--',
];

export const anionsProp = [
  { Ion: 'SO4--', ionType: 'anions', IonCode: 'SO4--', mass: 96.064, charge: -2 },
  {
    Ion: 'Cl-',
    ionType: 'anions',
    IonCode: 'Cl-',
    mass: 35.453,
    charge: -1,
  },
  {
    Ion: 'F-',
    ionType: 'anions',
    IonCode: 'F-',
    mass: 18.998,
    charge: -1,
  },
  {
    Ion: 'NO3-',
    ionType: 'anions',
    IonCode: 'NO3-',
    mass: 62.004,
    charge: -1,
  },
  {
    Ion: 'Br-',
    ionType: 'anions',
    IonCode: 'Br-',
    mass: 79.904,
    charge: -1,
  },
  {
    Ion: 'PO4---',
    ionType: 'anions',
    IonCode: 'PO4---',
    mass: 94.971,
    charge: -3,
  },
  {
    Ion: 'B-',
    ionType: 'anions',
    IonCode: 'B-',
    mass: 10.811,
    charge: -1,
  },
  {
    Ion: 'SiO2',
    ionType: 'anions',
    IonCode: 'SiO2',
    mass: 60.084,
    charge: 0,
  },
  {
    Ion: 'H2S',
    ionType: 'anions',
    IonCode: 'H2S',
    mass: 34.082,
    charge: 0,
  },
  {
    Ion: 'HCO3-',
    ionType: 'anions',
    IonCode: 'HCO3-',
    mass: 61.017,
    charge: 1,
  },
  {
    Ion: 'CO2',
    ionType: 'anions',
    IonCode: 'CO2',
    mass: 44.01,
    charge: 0,
  },
  {
    Ion: 'CO3--',
    ionType: 'anions',
    IonCode: 'CO3--',
    mass: 60.009,
    charge: 2,
  },
];

export const cationsProp = [
  {
    Ion: 'Ca++',
    ionType: 'cations',
    IonCode: 'Ca++',
    mass: 40.078,
    charge: 2,
  },
  {
    Ion: 'Mg++',
    ionType: 'cations',
    IonCode: 'Mg++',
    mass: 24.305,
    charge: 2,
  },
  {
    Ion: 'Na+',
    ionType: 'cations',
    IonCode: 'Na+',
    mass: 22.99,
    charge: 1,
  },
  {
    Ion: 'K+',
    ionType: 'cations',
    IonCode: 'K+',
    mass: 39.098,
    charge: 1,
  },
  {
    Ion: 'Fe++',
    ionType: 'cations',
    IonCode: 'Fe++',
    mass: 55.845,
    charge: 2,
  },
  {
    Ion: 'Ba++',
    ionType: 'cations',
    IonCode: 'Ba++',
    mass: 137.327,
    charge: 2,
  },
  {
    Ion: 'Mn++',
    ionType: 'cations',
    IonCode: 'Mn++',
    mass: 54.931,
    charge: 2,
  },
  {
    Ion: 'NH4+',
    ionType: 'cations',
    IonCode: 'NH4+',
    mass: 18.038,
    charge: 1,
  },
  {
    Ion: 'Sr++',
    ionType: 'cations',
    IonCode: 'Sr++',
    mass: 87.62,
    charge: 2,
  },
];

export const disabledCells = [
  { rowId: 'NH4+', colId: ['Meq', 'ppmAsCaCO3'] },
  { rowId: 'F-', colId: ['Meq', 'ppmAsCaCO3'] },
  { rowId: 'PO4---', colId: ['Meq', 'ppmAsCaCO3'] },
  { rowId: 'B-', colId: ['Meq', 'ppmAsCaCO3'] },
  { rowId: 'SiO2', colId: ['Meq', 'ppmAsCaCO3'] },
  { rowId: 'H2S', colId: ['Meq', 'ppmAsCaCO3'] },
  { rowId: 'HCO3-', colId: 'all' },
  { rowId: 'CO2', colId: 'all' },
  { rowId: 'CO3--', colId: 'all' },
  { rowId: 'Total Cations', colId: 'all' },
  { rowId: 'Total Anions', colId: 'all' },
];

export const waterCompositionsData = {
  1: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mg++', IonCode: 'Mg++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      { Ion: 'SO4--', IonCode: 'SO4--', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Cl-', IonCode: 'Cl-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  2: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 408, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 1298,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 10768, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 396, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 2702,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 19361,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 67, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  3: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 83, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 25,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 106, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 8, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 2,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.0500000007450581,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mn++',
        IonCode: 'Mn++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 130,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 182.949996948242,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'F-', IonCode: 'F-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 1,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  4: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 200, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 100,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 388, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.00999999977648258,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Cl-', IonCode: 'Cl-', MgL: 881, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'F-',
        IonCode: 'F-',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'B-',
        IonCode: 'B-',
        MgL: 1.10000002384186,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 20, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  5: {
    cations: [
      {
        Ion: 'Ca++',
        IonCode: 'Ca++',
        MgL: 1200,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 125,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 10, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.00999999977648258,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 2387.8701171875,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'F-',
        IonCode: 'F-',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'B-',
        IonCode: 'B-',
        MgL: 1.10000002384186,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 50, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  6: {
    cations: [
      {
        Ion: 'Ca++',
        IonCode: 'Ca++',
        MgL: 1000,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 100,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 10, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.00999999977648258,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 2300,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'F-',
        IonCode: 'F-',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 50, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  7: {
    cations: [
      {
        Ion: 'Ca++',
        IonCode: 'Ca++',
        MgL: 1200,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 125,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 10, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 2387.8701171875,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 50, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  8: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mg++', IonCode: 'Mg++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Na+',
        IonCode: 'Na+',
        MgL: 8.01000022888184,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'K+', IonCode: 'K+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      { Ion: 'SO4--', IonCode: 'SO4--', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Cl-', IonCode: 'Cl-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'SiO2',
        IonCode: 'SiO2',
        MgL: 0.5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
};

export const inputTypes = [
  { text: 'Alkalinity & pH', id: 'ph_alk' },
  { text: 'Bicarbonate & pH', id: 'ph_hco3' },
  { text: 'CO2 & Bicarbonate', id: 'co2_hco3' },
];

export const defaultMessage = {
  open: false,
  message: 'Something went wrong',
  okText: 'Ok',
  cancelText: 'Cancel',
  confirm: false,
};
export const clonedWaterCompData = {
  1: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mg++', IonCode: 'Mg++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      { Ion: 'SO4--', IonCode: 'SO4--', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Cl-', IonCode: 'Cl-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  2: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 408, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 1298,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 10768, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 396, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 2702,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 19361,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 67, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  3: { // surface water
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 83, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 25,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 106, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 8, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 2,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.0500000007450581,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0.1, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mn++',
        IonCode: 'Mn++',
        MgL: 0.05,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 130,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 182.949996948242,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'F-', IonCode: 'F-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 1,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  4: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 200, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 100,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 388, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.00999999977648258,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 5, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Cl-', IonCode: 'Cl-', MgL: 881, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'F-',
        IonCode: 'F-',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'B-',
        IonCode: 'B-',
        MgL: 1.10000002384186,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 20, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  5: {
    cations: [
      {
        Ion: 'Ca++',
        IonCode: 'Ca++',
        MgL: 1200,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 125,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 10, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.00999999977648258,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 2387.8701171875,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'F-',
        IonCode: 'F-',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'B-',
        IonCode: 'B-',
        MgL: 1.10000002384186,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 50, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  6: {   // Brackish water
    cations: [
      {
        Ion: 'Ca++',
        IonCode: 'Ca++',
        MgL: 1000,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 100,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 10, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Ba++',
        IonCode: 'Ba++',
        MgL: 0.00999999977648258,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Sr++',
        IonCode: 'Sr++',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0.1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 2300,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'F-',
        IonCode: 'F-',
        MgL: 0.100000001490116,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0.1,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 30, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  7: {  // well water
    cations: [
      {
        Ion: 'Ca++',
        IonCode: 'Ca++',
        MgL: 1200,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Mg++',
        IonCode: 'Mg++',
        MgL: 125,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Na+', IonCode: 'Na+', MgL: 250, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'K+', IonCode: 'K+', MgL: 10, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0.2, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      {
        Ion: 'SO4--',
        IonCode: 'SO4--',
        MgL: 500,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'Cl-',
        IonCode: 'Cl-',
        MgL: 2387.8701171875,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 1, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0.1,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'SiO2', IonCode: 'SiO2', MgL: 50, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
  8: {
    cations: [
      { Ion: 'Ca++', IonCode: 'Ca++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mg++', IonCode: 'Mg++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'Na+',
        IonCode: 'Na+',
        MgL: 8.01000022888184,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'K+', IonCode: 'K+', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'NH4+',
        IonCode: 'NH4+',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'Ba++', IonCode: 'Ba++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Sr++', IonCode: 'Sr++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Fe++', IonCode: 'Fe++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Mn++', IonCode: 'Mn++', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
    ],
    anions: [
      { Ion: 'SO4--', IonCode: 'SO4--', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Cl-', IonCode: 'Cl-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'F-', IonCode: 'F-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'NO3-', IonCode: 'NO3-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      { Ion: 'Br-', IonCode: 'Br-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'PO4---',
        IonCode: 'PO4---',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      { Ion: 'B-', IonCode: 'B-', MgL: 0, Meq: 0, ppmAsCaCO3: 0 },
      {
        Ion: 'SiO2',
        IonCode: 'SiO2',
        MgL: 0.5,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'H2S',
        IonCode: 'H2S',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'HCO3-',
        IonCode: 'HCO3-',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO2',
        IonCode: 'CO2',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
      {
        Ion: 'CO3--',
        IonCode: 'CO3--',
        MgL: 0,
        Meq: 0,
        ppmAsCaCO3: 0,
      },
    ],
  },
};

export const defaultUnitValues = {
  temp: '°C',
  pressure: 'atm',
  flow: 'gpm',
  flux: 'gfd',
  power: 'kW',
  volume: 'gal',
  type: 'custom',
};

export const unitsForTemp = [
  { id: '°F', name: '°F' },
  { id: '°C', name: '°C' },
];

export const unitsForPressure = [
  { id: 'psi', name: 'psi' },
  { id: 'bar', name: 'bar' },
  { id: 'kPa', name: 'kPa' },
  { id: 'MPa', name: 'MPa' },
  { id: 'atm', name: 'atm' },
  { id: 'lbf/ft2', name: 'lbf/ft2' },
  { id: 'kgf/cm2', name: 'kgf/cm2' },
  { id: 'kgf/m2', name: 'kgf/m2' }, // unit for pressure
  { id: 'ft H2O', name: 'ft H2O' },
  { id: 'in H2O', name: 'in H2O' },
  { id: 'in Hg', name: 'in Hg' },
  { id: 'mm Hg', name: 'mm Hg' },
];

// factor for converting used specified unit to atm
export const unitsForPressure_atm = {

  'atm': 1.0,
  'psi': 0.06804596,
  'lbf/ft2': 0.000473,
  'ft H2O': 0.029499,
  'in H2O': 0.0024558598568961,
  'in Hg': 0.033421060942512,
  'mm Hg': 0.00131579,
  'kgf/cm2': 0.967857,
  'kgf/m2': 9.6784110535406E-5,  // unit for pressure
  'bar': 0.98692327,
  'kPa': 0.00986923,
  'MPa': 9.86923267,
};

export const unitsForVolume = [
  { id: 'gal', name: 'gal' },
  { id: 'm3', name: 'm3' },
  { id: 'l', name: 'l' },
  { id: 'ft3', name: 'ft3' },
];

export const unitsForFlux = [
  { id: 'gfd', name: 'gfd' },
  { id: 'lmh', name: 'lmh' },
  { id: 'lmd', name: 'lmd' },
  { id: 'm/s', name: 'm/s' },
  { id: 'm/hr', name: 'm/hr' },
];

export const unitsForPower = [
  { id: 'hp', name: 'hp' },
  { id: 'kW', name: 'kW' },
  { id: 'MW', name: 'MW' },
  { id: 'W', name: 'W' },
];

export const unitsForFlow = [
  { id: 'gpm', name: 'gpm' },
  { id: 'm3/hr', name: 'm3/hr' },
  { id: 'gpd', name: 'gpd' },
  { id: 'gph', name: 'gph' },
  { id: 'm3/s', name: 'm3/s' },
  { id: 'm3/day', name: 'm3/day' },
  { id: 'Bbl/hr', name: 'Bbl/hr' },
  { id: 'Bbl/day', name: 'Bbl/day' },
  { id: 'ft3/min', name: 'ft3/min' },
  { id: 'ft3/s', name: 'ft3/s' },
  { id: 'ft3/hr', name: 'ft3/hr' },
  { id: 'ft3/day', name: 'ft3/day' },
  { id: 'l/s', name: 'l/s' },
  { id: 'l/min', name: 'l/min' },
  { id: 'l/hr', name: 'l/hr' },
];

export const unitsForFlow_m3persec = {
  'gpm': 0.00006309, // 0.0000757683211,
  'gph': 0.000001052, // 0.0000013,
  // 'gpd': 0.00000004381, // 5.262E-8,
  'gpd': 0.0000000438126363888887, // 5.262E-8, // value updated by anitha
  'Bbl/hr': 0.0000441631, // 4.416313748E-5,
  'Bbl/day': 0.00000184013, // 1.8401307283333E-6,
  'l/s': 0.001,
  'ft3/s': 0.0283168466,
  'ft3/hr': 0.00000786579, // 7.86579072E-6,
  'ft3/day': 0.000000327741, // 3.2774128E-7,
  'ft3/min': 0.000471947, // 0.000471947443,
  'm3/s': 1,
  'm3/hr': 0.000277777777777778, // 0.000277777778,
  'm3/day': 0.0000115740740740741, // 1.15740741E-5,
  'l/min': 0.0000166666666666667, // 1.66666667E-5,
  'l/hr': 2.77777777777778E-07, // 2.77777778E-7
};

export const saturationDetails = {
  baso4: '0.00',
  caf2: '0.00',
  caso4: '0.00',
  sio2: '0.00',
  srso4: '0.00',
  struvite: '0.00',
  lsi: '0.00',
  sdi: '0.00',
  osmotic_pressure: '0.00',
  conductivity: '0',
  density: '0.00',
  mgoh2: '0.00',
};

export const defaultModalOptions = {
  visible: false,
  message: 'Something went wrong',
  title: 'Warning',
  onNo: null,
  onYes: null,
  yesOrNo: true,
  type: 'warning'
};

export const defaultRoTableData = () => {
  const arr = [];
  for (let i = 1; i < 9; i += 1) {
    arr.push({
      stage: i,
      pressureVessels: '0',
      elementsperVessel: 0,
      application: ' ',
      elementGroup: ' ',
      elementModel: ' ',
      elementAge: '0.00',
      fluxAnnual: '0.00',
      saltPassageAnnual: '0.00',
      permeatePressure: '0.00',
      interStageBoostPressure: i === 1 ? '' : '0.00',
      boostEnergyEfficiency: i === 1 ? '' : '0.00',
      interStagePressureLoss: '0.00'
    });
  }
  return arr;
};

export const defaultCLRoTableData = () => {
  const arr = [];
  for (let i = 1; i < 2; i += 1) {
    arr.push({
      stage: i,
      pressureVessels: '0',
      elementsperVessel: 0,
      spacersperVessel: 0,
      application: ' ',
      elementGroup: ' ',
      elementModel: ' ',
      elementAge: '0.00',
      fluxAnnual: '0.00',
      saltPassageAnnual: '0.00',
      permeatePressure: '0.00',
      // interStageBoostPressure: '0.00',
      // boostEnergyEfficiency: '0.00',
      // interStagePressureLoss: '0.00'
    });
  }
  return arr;
};

// commented on 28th-Nov-2023 by Abhishek :- unused code
// export const defaultRangeUnits = {
//   atm: [0, 68.05],
//   psi: [0, 1000],
//   bar: [0, 68.9516625],
//   'lbf/ft2': [0, 144009.54],
//   'ft H2O': [0, 2306.795558841429],
//   'in H2O': [0, 27682.35],
//   'in Hg': [0, 2036.1412259489546],
//   'mm Hg': [0, 51718],
//   'kgf/cm2': [0, 70.3111],
//   'kgf/m2': [0, 702595],  // new unit for pressure
//   'kPa': [0, 6895.16625],
//   'MPa': [0, 6.8952E9]
// };

export const defaultElementParameters = {
  'Area': 0,
  'Nano(0)': '0',
  'Nano(1)': '0',
  'Nano(2)': '0',
  'Nano(3)': '0',
  'Nano(4)': '0',
  'Nano(x)': '',
};

export const localstorageVal = [
  'hppump_', 'feed_', 'wasteout_', 'mixsplit_', 'pump_',
  'cartridge_', 'cf_', 'product_', 'chemicaldosing_',
  'roPump_', 'stripper_', 'cls_', 'work_', 'edi_',
  'wexpex_', 'wex_', 'ro_', 'peltonwheel_', 'TC_', 'tc_', 'nf_', 'nfPump_',
  'turbocharger_'
];
export const getCommonData = (str, disabled) => {
  const obj = { str, disabled };
  if ((str === 'specifyflow') || (str === 'calculate')) {
    obj.title = (str === 'specifyflow') ? 'Specify Flow' : 'Calculate';
    obj.oriImg = (str === 'specifyflow') ? specifyFlowIcon : executeImage;
    obj.hovImg = (str === 'specifyflow') ? specifyFlowIconColor : executeImageColor;
    obj.class = str;
  } else if ((str === 'stream') || (str === 'explorer')) {
    obj.title = (str === 'stream') ? 'Stream Data' : 'Explorer';
    obj.oriImg = (str === 'stream') ? streamImage : explorerImage;
    obj.hovImg = (str === 'stream') ? streamImageColor : explorerImageColor;
    obj.class = str;
  } else if (str === 'error' || str === 'pdf-report') {
    obj.title = str === 'error' ? 'Notifications' : 'Generate Report';
    obj.oriImg = str === 'error' ? notificationImage : pdfReportImage;
    obj.hovImg = str === 'error' ? notificationImageColor : pdfReportImageColor;
    obj.class = str;
  }
  return obj;
};
export const executeDefault = [
  { ...getCommonData('specifyflow', false) },
  { ...getCommonData('calculate', false) },
  { ...getCommonData('stream', true) },
  { ...getCommonData('explorer', true) },
  { ...getCommonData('pdf-report', true) },
  { ...getCommonData('error', true) },
];
export const executeNoError = (flag = false) => {
  return [
    { ...getCommonData('specifyflow', false) },
    { ...getCommonData('calculate', false) },
    { ...getCommonData('stream', false) },
    { ...getCommonData('explorer', flag) },
    { ...getCommonData('pdf-report', false) },
    {
      'str': 'error',
      'title': 'No Errors / Warnings detected',
      'oriImg': notificationSuccessImage,
      'hovImg': notificationSuccessImageColor,
      'disabled': true
    }
  ];
};
export const executeError = (str, flag = false) => {
  return [
    { ...getCommonData('specifyflow', false) },
    { ...getCommonData('calculate', false) },
    { ...getCommonData('stream', false) },
    { ...getCommonData('explorer', flag) },
    { ...getCommonData('pdf-report', false) },
    {
      'str': 'error',
      'title': 'Errors / Warnings detected',
      'oriImg': (str === 'warning') ? notificationWarningImage : notificationErrorImage,
      'hovImg': (str === 'warning') ? notificationWarningImageColor : notificationErrorImageColor,
      'disabled': false
    }
  ];
};
// sorting RO data based on sequence in unitop. start
export const sortingRoData = () => {
  let x_axis_cordinate = [];
  const exisingVal = [];
  const sortingVal = [];
  const localStorageId = [];
  document.querySelectorAll('.react-flow__nodes .react-flow__node').forEach((ele) => {
    x_axis_cordinate.push(Number(ele.style.transform.split('translate')[1].split(',')[0].split('px')[0].split('(')[1]));
  });
  x_axis_cordinate = x_axis_cordinate.map(Number).sort((a, b) => a > b ? 1 : -1);
  x_axis_cordinate.map((ele1) => {
    document.querySelectorAll('.react-flow__nodes .react-flow__node').forEach((ele, index) => {
      const val = Number(ele.style.transform.split('translate')[1].split(',')[0].split('px')[0].split('(')[1]);
      if (ele1 === val && exisingVal.indexOf(val) < 0) {
        exisingVal.push(val);
        const htmlNode = document.querySelectorAll('.react-flow__nodes .react-flow__node')[index];
        if (htmlNode.className.indexOf('customnode_ROpump') >= 0 || htmlNode.className.indexOf('customnode_CLROpump') >= 0 || htmlNode.className.indexOf('customnode_NFpump') >= 0) {
          sortingVal.push(localStorage.getItem(htmlNode.getAttribute('data-id')));
          localStorageId.push(htmlNode.getAttribute('data-id'));
        } else if (htmlNode.className.indexOf('customnode_product') >= 0 && htmlNode.getAttribute('data-id').indexOf('product') < 0) {
          sortingVal.push(localStorage.getItem(htmlNode.getAttribute('data-id')));
          localStorageId.push(htmlNode.getAttribute('data-id'));
        }
      }
    });
  });
  return { sortingVal, localStorageId };
};
// sorting RO data based on sequence in unitop. End

export const copyRightText = 'Copyright &#169; 2025, Veolia Water Technologies & Solutions.';
export const defaultSetUnitsetdict = (str, data) => {
  const obj = {
    'Volume Flow': 'm3/hr',
    'Pressure': 'bar',
    'Temperature': '°C',
    'Liquid Volume': 'gal',
    'Flux': 'gfd',
    'Power': 'kW'
  };
  obj['Volume Flow'] = data.flow || data['Volume Flow'] || obj['Volume Flow'];
  obj.Pressure = data.pressure || data.Pressure || obj.Pressure;
  obj.Temperature = data.temp || data.Temperature || obj.Temperature;
  obj['Liquid Volume'] = data.volume || data['Liquid Volume'] || obj['Liquid Volume'];
  obj.Flux = data.flux || data.Flux || obj.Flux;
  obj.Power = data.power || data.Power || obj.Power;
  localStorage.setItem(str, JSON.stringify(obj));
};
export default waterType;

export const support_email = 'winflows_support@veolia.com';
// export const test_email = 'wtstestuser01a@gmail.com';
export const test_email = 'veolia3450@gmail.com';
export const user1_email = 'abhishek.kumar.ext@veolia.com';
export const user2_email = 'anitha-sravya.chanumolu@veolia.com';
export const user3_email = 'jens.lipnizki@veolia.com';
export const user4_email = 'kin-ho.wee@veolia.com';
export const fatalMarkersData = ['FATAL ERROR!!', '严重错误！！', '严重错误!!', '严重错误！!', '¡ERROR FATAL!', 'ERREUR FATALE !!', 'SCHWERWIEGENDER FEHLER!!'];
export const warningMarkerData = ['WARNING!!', '警告！！', '警告!!', '警告！!', '建议！！', '¡ADVERTENCIA!', 'AVERTISSEMENT !!', 'WARNUNG!!'];
